
WB.WidgetGrids = WB.WidgetGrids || {};

WB.WidgetGrids.WidgetGridThreeDirectiveLink = function (scope, element, attr) {
};

WB.WidgetGrids.WidgetGridThreeDirective = function () {
    return {
        scope: {
            grid: '='
        },
        restrict: 'AE',
        link: WB.WidgetGrids.WidgetGridThreeDirectiveLink,
        template: `<ul class="widget-grid js-widget-grid" data-layout-id="{{ grid.LayoutId }}">
        <div wb-widget-grid-widget-item widget="grid.Widgets[0]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[1]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[2]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[3]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[4]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[5]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[6]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[7]"></div>
        <div wb-widget-grid-widget-item widget="grid.Widgets[8]"></div>
    </ul>`
    };
};
WB.App.directive('wbWidgetGridThree', WB.WidgetGrids.WidgetGridThreeDirective);
